import React, { useState, useEffect } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, Row,ModalHeader,} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const Company = () => {

  function tog_list() {
    setmodal_list(!modal_list);
    setEditCompany(null);
  }
     const [isLoading, setIsLoading] = useState(false);
  const [modal_list, setmodal_list] = useState(false);
  const [editCompany, setEditCompany] = useState(null);
  const [formData, setFormData] = useState({name: "", logo: null });

  useEffect(() => {
    if (editCompany) {
      setFormData({
        name: editCompany.name,
        logo: null,
      });
    } else {
      setFormData({
        name: "",
        logo: null,
      });
    }
  }, [editCompany]);

  const [responseMessage, setResponseMessage] = useState("");
  const handleInputChange = (e) => {
    if (e.target.type === "file") {
      setFormData({ ...formData, logo: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.id]: e.target.value });
    }
  };
    const authToken =localStorage.getItem("access");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
       setIsLoading(true)
      const apiUrl = editCompany
        ? `https://api.hanoch.in/api/company/${editCompany._id}`
        : "https://api.hanoch.in/api/company/";
      const formDataObject = new FormData();
      formDataObject.append("name", formData.name);
      formDataObject.append("logo", formData.logo);
      const response = await fetch(apiUrl, {
        method: editCompany ? "PATCH" : "POST",
        // headers: {
        //   Authorization: `Bearer ${authToken}`,
        // },
        body: formDataObject,
      });
      const responseData = await response.json();
      if (response.ok) {
        setmodal_list(false);
        toast.success(responseData.message);
        setFormData({
          name: "",
          logo: null,
        });
        fetchCompany();

        // setmodal_list_edit(false);
      } else {
        toast.error(`Error: ${responseData.error}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
     finally{
        setIsLoading(false);
    }
  };

  const [companyData, setCompanyData] = useState([]);
  const fetchCompany = async () => {
    try {
      setIsLoading(true)
      const response = await fetch("https://api.hanoch.in/api/company", {
      });

      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setCompanyData(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
     finally{
        setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, []);

  const handleDeleteMachine = async (machineId) => {
    try {
      // Make API request to delete the user
      const response = await fetch(
        `https://api.hanoch.in/api/company/${machineId}`,
        {
          method: "DELETE",
          // headers: {
          //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
          // },
        }
      );

      if (response.ok) {
        // If the deletion was successful, refresh the user data
        toast.success("Company Deleted Successfully");
        fetchCompany();
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
       localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else {
        toast.error("Error deleting data:", response.statusText);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredCompany = companyData.filter((company) =>
    company.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredCompany.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = filteredCompany.slice(indexOfFirstItem, indexOfLastItem);

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Company" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">
                    Add, Edit & Remove Company
                  </h4>
                </CardHeader>

                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div className="d-flex gap-1">
                          <Button
                            color="success"
                            className="add-btn"
                            onClick={() => tog_list()}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
{isLoading ? (
                      <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="sort" data-sort="customer_name">
                              Company Name
                            </th>
                            <th className="sort" data-sort="logo">
                              Company Logo
                            </th>
                            <th className="sort" data-sort="action">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {currentItems === undefined ? (
                            <tr>
                              <td colSpan="4" className="text-center">
                                Loading...
                              </td>
                            </tr>
                          ) : currentItems.length === 0 ? (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No content found
                              </td>
                            </tr>
                          ) : (
                            currentItems.map((machine, index) => (
                              <tr key={index}>
                                <td className="customer_name">
                                  {machine.name}
                                </td>
                                <td>
                                  {machine.logo && (
                                    <div className="logo">
                                      <img
                                        alt=""
                                        src={machine?.logo}
                                        height="48"
                                      />
                                    </div>
                                  )}
                                </td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <div className="edit">
                                      <button
                                        className="btn btn-warning"
                                        onClick={() => {
                                          setmodal_list(true);
                                          setEditCompany(machine);
                                        }}
                                      >
                                        Edit
                                      </button>
                                    </div>
                                    <div className="remove">
                                      <button
                                        className="btn btn-danger remove-item-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#deleteRecordModal"
                                        onClick={() =>
                                          handleDeleteMachine(machine.id)
                                        }
                                      >
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#121331,secondary:#08a88a"
                            style={{ width: "75px", height: "75px" }}
                          ></lord-icon>
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted mb-0">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>
                    )}
                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add Modal */}
      <Modal
        isOpen={modal_list}
        toggle={() => {
          // setmodal_list(false);
          tog_list();
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
          toggle={() => {
            tog_list();
          }}
        >
          {editCompany ? "Edit Company" : "Add Company"}
        </ModalHeader>
        {responseMessage && (
          <div
            className={`alert ${
              responseMessage.includes("Error")
                ? "alert-danger"
                : "alert-success"
            } `}
          >
            {responseMessage}
          </div>
        )}
        <form className="tablelist-form">
          <ModalBody>
            <div className="mb-3" id="modal-id" style={{ display: "none" }}>
              <label htmlFor="id-field" className="form-label">
                ID
              </label>
              <input
                type="text"
                id="id-field"
                className="form-control"
                placeholder="ID"
                readOnly
              />
            </div>

            <div className="mb-3">
              <label htmlFor="name-field" className="form-label">
                Company Name
              </label>
              <input
                type="text"
                id="name"
                className="form-control"
                placeholder="Company Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="logo-field" className="form-label">
                Company Logo
              </label>

              <input
                type="file"
                accept="image/*"
                id="logo"
                className="form-control"
                placeholder="Company Logo"
                // value={formData.logo}
                onChange={handleInputChange}
                required
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setmodal_list(false);
                  setEditCompany(null);
                }}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                onClick={handleSubmit}
              >
                {" "}
                {editCompany ? "Update Company" : "Add Company"}
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </React.Fragment>
  );
};

export default Company;
